<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class DevsettingEdit extends Vue {

  data = {}

  get columns() {
    return [
      {
        prop: 'blacklist_ips',
        label: 'IP黑名单',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'rack_attack_limit',
        label: '访问限制',
        form: {
          component: 'input',
          props: {
            placeholder: 'Rack attack limit'
          }
        }
      },
      {
        prop: 'rack_attack_period',
        label: '访问限制周期',
        form: {
          component: 'input',
          props: {
            placeholder: 'Rack attack period'
          }
        }
      },
      {
        prop: 'safelist_ips',
        label: 'IP白名单',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'disabled_puchase_only_shop_i_id',
        label: '不可单独购买产品货号',
        form: {
          component: 'input',
          props: {
            placeholder: '1213W'
          }
        }
      },
      {
        prop: 'enabled_sms_server',
        label: '开启短信服务',
        form: {
          component: 'switch'
        }
      },
      {
        prop: 'increase_initial_sale_count_day',
        label: '产品初始销量随机增长天数',
        form: {
          component: 'inputNumber',
          props: {
            hint: '默认为10天'
          }
        }
      }
    ];
  }

  async fetchData() {
    this.data = await this.$request.get('/settings');
  }

  async mounted() {
    this.fetchData();
  }

  async handleUpdate(data) {
    await this.$autoLoading(
      this.$request.put('/settings', data)
    );
    this.$message.success('更新成功');
    this.fetchData();
  }
}
</script>
